export function getLocalData(key) {
    if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
        return;
    }
    try {
        const data = localStorage.getItem(key);
        if (data) {
            return JSON.parse(data);
        }
    }
    catch {
        console.warn(`Local storage item ${key} contains invalid json.`);
    }
    return undefined;
}
export function setLocalData(key, data) {
    if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
        return;
    }
    localStorage.setItem(key, JSON.stringify(data));
}
